import { cn, ia } from 'lib/helpers/utility';

export const getPanelClasses = ({ isFixed, position, options, panelClassName }) => {
  return cn(
    'z-[100] flex max-h-[95dvh] min-w-[120px] max-w-[712px] flex-col gap-y-2 rounded-lg bg-white py-2 shadow-[0px_2px_16px_0px_rgba(0,79,107,0.2)]',
    !isFixed && 'absolute mt-[6px]',
    !isFixed && position === 'left' ? 'right-0' : 'left-0',
    !ia(options) && 'overflow-hidden',
    panelClassName
  );
};
